import classes from "./Charts.module.css";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import SubsystemPopupMenu from "../subSystem/popupMenu/SubsystemPopupMenu";
import Badge from "@material-ui/core/Badge";
import SubsystemPopupMenuVars from "../subSystem/popupMenu/vars/SubsystemPopupMenuVars";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useStore } from "../../hooks/store";
import ChartsList from "./list/ChartsList";
import { LoadingRise } from "../UI/spinners/LoadingSpinners";
import { useTranslation } from "react-i18next";
import { chartsUrls } from "../../../SMARTCITY/hardCodeData/DATA";
import LanguageContext from "../../hooks/language-context";
import { useAllContexts } from "../../hooks/useAllContexts";
import FilterButton from "./FilterButton";
import styled from "styled-components";

const dateHashMap = [
  { title: "Σήμερα", id: 1 },
  { title: "Χθές", id: 2 },
  { title: "Τελευταίες 7 μέρες", id: 3 },
  { title: "Τελευταίες 30 μέρες", id: 4 },
];
const Charts = (props) => {
  const { sensorTypes, environment, meteo } = useAllContexts();
  const { SensorTypesData } = sensorTypes;
  const { environmentalData } = environment;
  const { meteoInfoData } = meteo;
  const languageCtx = useContext(LanguageContext);

  const [activeSensorType, setActiveSensorType] = useState(null);
  const [activeStation, setActiveStation] = useState(null);
  const [activeVariables, setActiveVariables] = useState(null);
  const [activePeriod, setActivePeriod] = useState(2);

  const [stationOptions, setStationOptions] = useState([]);
  const [variableOptions, setVariableOptions] = useState([]);

  useEffect(() => {
    console.log("activePEriod:", activePeriod);
    console.log("datehasmap:", dateHashMap);
    console.log(
      "date find 1",
      dateHashMap.filter((date) => date.id === activePeriod)?.[0]?.title
    );
  }, [activePeriod]);

  useEffect(() => {
    if (activeSensorType) {
      setActiveStation(null);
      switch (activeSensorType) {
        case "1": {
          const tempData = environmentalData?.map((item) => {
            return {
              title: item.mysensor_name,
              id: item.mysensor_id,
            };
          });
          console.log("tempData:", tempData);
          setStationOptions(tempData);
          break;
        }
        case "5": {
          const tempData = meteoInfoData.map((item) => {
            return {
              title: item.mysensor_name,
              id: item.mysensor_id,
            };
          });
          setStationOptions(tempData);
          break;
        }
        default:
          setStationOptions([]);
          break;
      }
    }
  }, [activeSensorType]);

  useEffect(() => {
    if (activeStation) {
      switch (activeSensorType) {
        case "1": {
          const tempDetails = environmentalData
            ?.filter((item) => item.mysensor_id === activeStation)?.[0]
            ?.details.map((detail) => ({
              title: detail.sensorvar_description,
              id: detail.sensorvar_id,
            }));

          setVariableOptions(tempDetails);
          break;
        }
        case "5": {
          const tempDetails = meteoInfoData
            .filter((item) => item.mysensor_id === activeStation)?.[0]
            ?.details?.map((detail) => {
              return {
                title: detail.sensorvar_description,
                id: detail.sensorvar_icon.slice(0, -4),
              };
            });
          setVariableOptions(tempDetails);
          break;
        }
        default:
          setVariableOptions([]);
          break;
      }
    }
  }, [activeStation]);

  useEffect(() => {
    if (activeSensorType && activeStation) callStats();
  }, [activeSensorType, activeStation, activePeriod, languageCtx.languageCode]);

  const [loadingStats, setLoadingStats] = useState(false);

  const [statsData, setStatsData] = useState([]);

  const [searchInput, setSearchInput] = useState("");
  const [filtersVars, setFiltersVars] = useState([]);

  const { t } = useTranslation();
  const typeNamePath = useRef(null);
  const sensorNamePath = useRef(null);

  const callStats = async () => {
    setLoadingStats(true);
    const req = await fetch(
      `${chartsUrls}&category=${activeSensorType}&sensor=${activeStation}&period=${activePeriod}&lang=${languageCtx.languageCode}`
    ).catch((error) => console.warn(error));

    if (req === undefined || !req.ok) {
      setLoadingStats(false);
      return;
    }

    const responseData = await req.json();

    setStatsData(responseData);
    setLoadingStats(false);
  };

  const handleTitle = (title) => title.replace(" ", "\n");

  return (
    <Fragment>
      <div className={classes.subsystem_container}>
        <div className={classes.search_subsystem_layout}>
          <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
            {t("Γραφήματα Δεδομένων Υποσυστημάτων")}
          </h2>
          <div className={classes.select_place}>
            <SelectionWrapper>
              <FilterButton
                data={SensorTypesData?.filter(
                  (type) => type.id === "1" || type.id === "5"
                )}
                setAction={(event) => setActiveSensorType(event)}
                type="subsystem"
              />

              {activeSensorType ? (
                <div style={{ whiteSpace: "pre", textAlign: "center" }}>
                  {handleTitle(
                    SensorTypesData?.find(
                      (item) => item.id === activeSensorType
                    ).title
                  )}
                </div>
              ) : (
                <div style={{ height: "38px" }}></div>
              )}
            </SelectionWrapper>

            <SelectionWrapper>
              <FilterButton
                data={stationOptions}
                setAction={(event) => setActiveStation(event)}
                type="station"
              />
              {activeStation ? (
                <div style={{ minHeight: "38px" }}>
                  {
                    stationOptions?.find((item) => item.id === activeStation)
                      .title
                  }
                </div>
              ) : (
                <div style={{ height: "38px" }}></div>
              )}
            </SelectionWrapper>
            <SelectionWrapper>
              <FilterButton
                data={variableOptions}
                setAction={(event) => setActiveVariables(event)}
                type="variable"
              />
              <div style={{ height: "38px" }}></div>
            </SelectionWrapper>
            <SelectionWrapper>
              <FilterButton
                data={dateHashMap}
                setAction={(event) => setActivePeriod(event)}
                type="period"
                activePeriod={activePeriod}
              />
              {activePeriod ? (
                <div style={{ height: "38px" }}>
                  {`${
                    dateHashMap.filter((date) => date.id === activePeriod)?.[0]
                      ?.title
                  }`}
                </div>
              ) : (
                <div style={{ height: "38px" }}></div>
              )}
            </SelectionWrapper>
          </div>
          {/* <SelectedItems>
            {activeSensorType && (
              <div>
                {
                  SensorTypesData?.find((item) => item.id === activeSensorType)
                    .title
                }{" "}
                >
              </div>
            )}
            {activeStation && (
              <div>
                {
                  stationOptions?.find((item) => item.id === activeStation)
                    .title
                }{" "}
                >
              </div>
            )}
            {activePeriod && (
              <div>
                {
                  dateHashMap.find((date) => `${date.id}` === activePeriod)
                    .title
                }
              </div>
            )}
          </SelectedItems> */}
        </div>
      </div>

      {!loadingStats && (
        <ChartsList
          stats={statsData}
          type={activePeriod}
          searchInput={searchInput}
          filtersVars={filtersVars}
        />
      )}

      {loadingStats && <LoadingRise />}
    </Fragment>
  );
};

export default Charts;

const SelectedItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const SelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;
